import React, {useEffect, useState} from 'react';
import {DataGrid} from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import {BrickContext} from 'olympe';
import {getChangeLogLambda} from '../../../../utils/functionSignatures';
import {LinearProgress, Tooltip} from '@mui/material';
import {LAMBDA_NAMES} from '../../../../utils/constants';

/**
 * @param {*} props
 * @return {JSX.Element}
 */
export function ChangeLog(props) {
    const getChangeLog = props.context.get(LAMBDA_NAMES.GET_CHANGE_LOG);
    const toolTipRenderer = (params) => (
        <Tooltip title={params.value.length > 25 ? params.value : ''} >
            <span className="MuiDataGrid-cellContent">{params.value}</span>
        </Tooltip>
    );

    const columns = [
        {field: 'modifier_name', headerName: 'Name', width: 170},
        {field: 'modifier_userid', headerName: 'User ID', width: 130},
        {field: 'field', headerName: 'Field', width: 180},
        {field: 'section', headerName: 'Section', width: 150},
        {field: 'old_value', headerName: 'Old Value', width: 200, renderCell: toolTipRenderer},
        {field: 'new_value', headerName: 'New Value', width: 200, renderCell: toolTipRenderer},
        {field: 'change_date', headerName: 'Modification date', width: 250},
    ];

    const [pageState, setPageState] = useState({
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
    });

    useEffect(() => {
        setPageState((prevState) => ({...prevState, isLoading: true}));
        getChangeLogLambda(
            props.context,
            getChangeLog,
            props.prTag,
            pageState.pageSize,
            pageState.page * pageState.pageSize,
            (result) => {
                const parsedResult = JSON.parse(result[0]);
                const totalResults = parseInt(result[1], 10);
                // Format date to readable date. MM/DD/YYYY, HH:MM AM
                const formatOptions = {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                };
                const logs = parsedResult.slice(1)?.map((log) => ({
                    ...log,
                    change_date: new Date(log.change_date).toLocaleDateString('en-US', formatOptions),
                }));
                setPageState((prevState) => ({...prevState, isLoading: false, data: logs, total: totalResults}));
            },
            () => {
                setPageState((prevState) => ({...prevState, isLoading: false}));
            });
    }, [pageState.page, pageState.pageSize]);


    const handlePageChange = (newPage) => {
        setPageState((old) => ({...old, page: newPage}));
    };

    const handlePageSizeChange = (newPageSize) => {
        setPageState((old) => ({...old, pageSize: newPageSize}));
    };

    const MyCustomNoRowsOverlay = () => (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>No changes made on this PR.</div>
    );

    return (
        <div style={{height: '600px', width: '100%'}}>
            <div style={{display: 'flex', height: '100%', width: '100%'}}>
                <div style={{flexGrow: 1}} className='change-log-datagrid' data-cy={'change-log-datagrid'}>
                    <DataGrid
                        data-cy={'change-log-grid'}
                        rows={pageState.data}
                        rowCount={pageState.total}
                        loading={pageState.isLoading}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        pagination
                        page={pageState.page}
                        pageSize={pageState.pageSize}
                        paginationMode="server"
                        onPageChange={handlePageChange}
                        onPageSizeChange={handlePageSizeChange}
                        columns={columns}
                        components={{
                            LoadingOverlay: LinearProgress,
                            NoRowsOverlay: MyCustomNoRowsOverlay,
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

ChangeLog.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string.isRequired,
};
